module.exports = __webpack_public_path__ + "img/3.2654fb4b.jpg";